import type { Dispatch } from 'redux';
import type { QuizzesState, QuizzesAction } from '@/redux/quizzes/types';

export enum Actions {
  SetQuizzesData = 'SetQuizzesData',
  SetQuizzesDataFail = 'SetQuizzesDataFail'
}

export const setQuizzesData =
  (data: QuizzesState) => (dispatch: Dispatch<QuizzesAction>) => {
    try {
      dispatch({ type: Actions.SetQuizzesData, data });
    } catch (error) {
      dispatch({ type: Actions.SetQuizzesDataFail, error });
    }
  };
